import { ref, computed, provide, watch, resolveComponent, openBlock, createElementBlock, normalizeClass, renderSlot, createCommentVNode, Fragment, renderList, createBlock } from 'vue';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { INPUT_EVENT, CHANGE_EVENT } from './utils/constants';
import SpRadio from './radio';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * radioGroup类型
   * linear: 默认线性选中类型
   * fill: 填充选中类型
   */
  type: propTypes.string().def('linear'),
  /**
   * radio组的name名称
   */
  groupName: propTypes.string().def(Math.random().toString()),
  /**
   * 选中的值
   */
  modelValue: propTypes.oneOfType([propTypes.number(), propTypes.string(), propTypes["boolean"]()]),
  /**
   * 配置项
   * [{label: xxx, value: xxx, disabled: false}]
   */
  options: propTypes.array().def([]),
  /**
   * 是否禁用
   */
  disabled: propTypes["boolean"]().def(false),
  /**
   * 选中icon位置
   */
  align: propTypes.string().def('left'),
  /**
   * label容器justify-content配置
   * start/end/between
   */
  justifyContent: propTypes.string().def('start'),
  /**
   * 横纵方向配置
   */
  direction: propTypes.string().def('vertical')
};
var emits = [INPUT_EVENT, CHANGE_EVENT];

var _createComponent = createComponent('radio-group'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  components: {
    SpRadio: SpRadio
  },
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      expose = _ref.expose;
    // 选中的值
    var radioGroupValue = ref(null);
    // 合并传入的相关配置
    var computedOptions = computed(function () {
      // 不存在options为空的情况，无需验证
      /* istanbul ignore next */
      return props.options ? props.options.map(function (option) {
        var disabled = option.disabled || props.disabled;
        return {
          option: _objectSpread2(_objectSpread2({}, option), {}, {
            disabled: disabled
          }),
          value: radioGroupValue.value === option.value,
          type: props.type,
          disabled: disabled,
          align: props.align,
          justifyContent: props.justifyContent,
          direction: props.direction
        };
      }) : [];
    });
    /**
     * 向子组件注入 updateRadioGroupValue 方法，支持radio选中结果进行更新
     */
    provide('updateRadioGroupValue', function (value) {
      radioGroupValue.value = value;
      emit(INPUT_EVENT, radioGroupValue.value);
      emit(CHANGE_EVENT, radioGroupValue.value);
    });
    // 向子组件注入选中的值
    provide('radioGroupValue', radioGroupValue);
    // 向子组件注入分组名称
    provide('radioGroupName', props.groupName);
    // 向子组件注入radioGroup是否被禁用
    provide('isGroupDisabled', props.disabled);
    // 向子组件注入radioGroup的类型
    provide('groupType', props.type);
    // 向子组件注入radioDirection的类型
    provide('groupDirection', props.direction);
    expose({
      isInGroup: true
    });
    /**
     * props.value发生变化时更新选中的值
     */
    watch(function () {
      return props.modelValue;
    }, function (val) {
      radioGroupValue.value = val;
    }, {
      immediate: true,
      deep: true
    });
    return {
      radioGroupValue: radioGroupValue,
      className: className,
      computedOptions: computedOptions
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_radio = resolveComponent("sp-radio");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className)
  }, [renderSlot(_ctx.$slots, "default", {}, function () {
    return [createCommentVNode(" radio遍历 如果外部有用到slot 则会被覆盖 "), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.computedOptions, function (opt) {
      return openBlock(), createBlock(_component_sp_radio, {
        key: opt.option.value,
        option: opt.option,
        value: opt.value,
        type: opt.type,
        disabled: opt.disabled,
        align: opt.align,
        direction: opt.direction,
        justifyContent: opt.justifyContent
      }, null, 8 /* PROPS */, ["option", "value", "type", "disabled", "align", "direction", "justifyContent"]);
    }), 128 /* KEYED_FRAGMENT */))];
  })], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/radio-group/radio-group.vue";

var _RadioGroup = script;

export { _RadioGroup as default };
